<template>
    <div class="outer-box">
        <h4>Delete Toll Free Ticket</h4>
        <div class="inner-box" style="text-align: left; width: 500px;">
            <div>Location ID</div>
            <input class="hl_input--wrap " type="text" placeholder="Location ID" v-model="locationId" />
            <br />
            <br />
            <button :disabled="disabled || processing" class="btn btn-danger mt-4" @click="deleteTollFree">
                <moon-loader v-if="processing" :loading="true" size="21px" color="#fafafa" />
                <span v-else>Delete Toll Free Ticket</span>
            </button>
            <pre v-if="response" style="background-color: #f2f7fa;padding: 16px; margin-top: 16px">{{ response }}</pre>
        </div>
    </div>
</template>

<script>
import { ISVService } from '@/services';

export default {
    data() {
        return {
            locationId: '',
            processing: false,
            response: null
        };
    },
    computed: {
        disabled() {
            if (!this.locationId) return true
            else return false
        }
    },
    methods: {
        async deleteTollFree() {
            try {
                this.processing = true
                this.response = (await ISVService.deleteTollFreeTicket(this.locationId)).data
            }
            catch (err) {
                this.response = err.response.data
            }
            finally {
                this.processing = false;
            }
        },
    }
}
</script>

<style></style>
